/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPresetsList } from "../funcs/riskPresetsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskPresetsResult } from "../models/components/riskpresetsresult.js";
import {
  ListRiskPresetsRequest,
  ListRiskPresetsSecurity,
} from "../models/operations/listriskpresets.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskPresetsQueryData = RiskPresetsResult;

export function prefetchRiskPresets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRiskPresetsRequest | undefined,
  security?: ListRiskPresetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskPresetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskPresetsQuery(
  client$: GramCore,
  request?: ListRiskPresetsRequest | undefined,
  security?: ListRiskPresetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RiskPresetsQueryData>;
} {
  return {
    queryKey: queryKeyRiskPresets({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskPresetsQueryFn(
      ctx,
    ): Promise<RiskPresetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskPresetsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskPresets(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "presets", "list", parameters];
}
